import { flattenToAxiosJsonApiQuery } from './flatten-to-axios-jsonapi-query'
import { parseJsonapiResponse } from './parse-jsonapi-response'
import { parseJsonapiError } from './parse-jsonapi-error'

export default {
  flattenToAxiosJsonApiQuery,
  parseJsonapiResponse,
  parseJsonapiError,
}
